import moment from 'moment';

export default (data, activity) => {
  const date = moment(data.date || undefined).format('YYYY-MM-DD');

  return {
    id: activity ? activity.id : undefined,

    daily_activity: {
      activity_time: `${date} ${data.time}`,
      data: {
        start_time: `${date} ${data.start_time}`,
        end_time: `${date} ${data.end_time}`,
        desc: data.description
      },
      is_staff_only: data.staffOnly
    }
  };
};
